import { useGlobalStore } from '@/stores/globalStore';
import { useOrderFormStore } from '@/stores/forms/orderFormStore';

function expressCheckoutEnabled() {
  const globalStore = useGlobalStore();
  console.log('express checkout enabled:::', globalStore?.expressCheckoutEnabled);
  const isEnabled = globalStore?.expressCheckoutEnabled ?? false;
  return isEnabled;
}

function isExpressCheckoutEnabledForMerchAndOrder() {
  const orderStore = useOrderFormStore();

  return (expressCheckoutEnabled()
  && orderStore.expressCheckout.isAnExpressOrder);
}

export { expressCheckoutEnabled, isExpressCheckoutEnabledForMerchAndOrder };
